import { RefObject, useEffect } from 'react';
import { VirtuosoMessageListMethods } from '@virtuoso.dev/message-list';
import { NinjaLoader } from 'src/components/Loading';
import {
  useActiveModel,
  useCompareMode,
  useCurrentConversation,
} from 'src/hooks';
import { MessageListOptimized } from './components/MessageListOptimized';
import { CompareModeType, Message } from 'src/types';
import { NINJA_AGENT_TEXT_AUTO_MODEL } from 'src/constants';

interface MessageListContainerProps {
  conversationId?: string;
  messageListRef: RefObject<VirtuosoMessageListMethods<Message>>;
  compareType?: CompareModeType;
}

export const MessageListContainer = ({
  conversationId,
  messageListRef,
  compareType,
}: MessageListContainerProps) => {
  const { isCurrentConversationLoading, currentConversation } =
    useCurrentConversation(conversationId);

  const { changeActiveModel } = useActiveModel();

  const { changeFirstCompareModel, changeSecondCompareModel } =
    useCompareMode();

  const handler =
    compareType === 'first'
      ? changeFirstCompareModel
      : compareType === 'second'
        ? changeSecondCompareModel
        : changeActiveModel;

  useEffect(() => {
    if (!currentConversation) {
      return;
    }

    const currentModel =
      currentConversation.model_ids?.[0] !== NINJA_AGENT_TEXT_AUTO_MODEL
        ? currentConversation.model_ids?.[0]
        : undefined;

    handler(currentModel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentConversation?.model_ids]);

  return (
    <>
      <MessageListOptimized
        messageListRef={messageListRef}
        conversationId={conversationId}
        compareType={compareType}
      />

      {isCurrentConversationLoading && (
        <NinjaLoader content="Ninja is loading the content" />
      )}
    </>
  );
};
